import React from 'react'
import './Reasons.css'
import image1 from '../../assets/image1.png'
import image2 from '../../assets/image2.png'
import image3 from '../../assets/image3.png'
import image4 from '../../assets/image4.png'
import tick from '../../assets/tick.png'
import Nb from '../../assets/nb.png'
import adidas from '../../assets/adidas.png'
import nike from '../../assets/nike.png'

const Reasons = () => {
  return (
    <div className='Reasons'id='WhyUs'>
        
        <div className='left-side'>
            <img src={image1} alt=''/>
            <img src={image3} alt=''/>
            <img src={image2} alt=''/>
            <img src={image4} alt=''/>
        </div>
        <div className='Right-side'>  
            <span>Some Reasons</span>
            <div>
                <span className='stroke-text'>Why</span>
                <span>choose us?</span>
            </div>
            <div className='details-r'>
                <div>
                    <img src={tick} alt='' />
                    <span>Over 140+ expert coachs</span>
                </div>
                <div>
                    <img src={tick} alt='' />
                    <span>train smarter and faster than before</span>
                </div>
                <div>
                    <img src={tick} alt='' />
                    <span>1 free program for new member</span>
                </div>
                <div>
                    <img src={tick} alt='' />
                    <span>reliable partners</span>
                </div>

            </div>
            <div>
                <span
                    style={{
                        color: "var(--gray)",
                        fontWeight: "bold",
                        
                    }}
                    >
                        Our partners</span>
                    <div className='partners'>
                        <img src={Nb} alt='' />
                        <img src={adidas} alt='' />
                        <img src={nike} alt='' />
                    </div>
                
            </div>
        </div>
    </div>
  )
}

export default Reasons